export const actions = {
  GET_TASKS_LIST: 'GET_TASKS_LIST',
  GET_TASKS_LIST_SUCCESS: 'GET_TASKS_LIST_SUCCESS',
  GET_TASKS_LIST_FAILURE: 'GET_TASKS_LIST_FAILURE',
  SET_TASKS_PAGE: 'SET_TASKS_PAGE',

  GET_TASK_DETAILS: 'GET_TASK_DETAILS',
  GET_TASK_DETAILS_SUCCESS: 'GET_TASK_DETAILS_SUCCESS',
  GET_TASK_DETAILS_FAILURE: 'GET_TASK_DETAILS_FAILURE',
};
